<template>
  <div class="full-width row">
    <div v-for="subtitle in subtitles" :key="'sub-' + subtitle.name" class="row text-caption align-items-center" :class="colSizeClass(subtitle.colSize)">
      <span>
        <translate>{{ subtitle.name }}</translate>
      </span>
      <div  v-for="option in subtitle.options" :key="'sub-' + subtitle.name + '-opt-' + option.name"
       class="row q-mx-md align-items-center">
        <span v-if="option.icon">
          <q-icon :name="option.icon" :color="option.classLegendColor" size="1.5rem">
          </q-icon>
        </span>
        <span v-else>
          <div class="color-box q-pa-sm q-ma-sm" :class="option.classLegendColor"></div>
        </span>
        <span class="text-bold" style="z-index: 6000;">
          <translate>{{ option.name }}</translate>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'JtDataGridSubtitle',
  props: {
    subtitles: {
      type: Array,
      required: true,
      default: []
    }
  }
})
class JtDataGridSubtitle extends Vue {
  beforeMount () {
    const example = [
      {
        name: 'SUBTITLE_TRANSLATE_NAME',
        colSize: 6,
        options: [
          {
            name: 'OPTION_1_TRANSLATE_NAME',
            classLegendColor: 'red-legend'
          },
          {
            name: 'OPTION_2_TRANSLATE_NAME',
            classLegendColor: 'yellow-legend'
          },
          {
            name: 'OPTION_3_TRANSLATE_NAME',
            classLegendColor: 'blue-legend'
          }
        ]
      }
    ]

    if (this.subtitles && this.subtitles instanceof Array && this.subtitles.length > 0) {
      this.subtitles.forEach(_subtitle => {
        if (_subtitle.name) {
          _subtitle.colSize = _subtitle.colSize || 12
          _subtitle.options = _subtitle.options || []

          if (_subtitle.options instanceof Array && _subtitle.options.length > 0) {
            _subtitle.options.forEach(_option => {
              if (_option.name) {
                _option.classLegendColor = _option.classLegendColor || 'blue-legend'
              } else {
                console.error(`One of the options into ${_subtitle.name} legend is missing the 'name' property.`)
              }
            })
          } else {
            console.error(`The ${_subtitle.name} subtitle has the 'options' property empty.`)
          }
        } else {
          console.error('One of the subtitles is missing the \'name\' property.')
        }
      })
    } else {
      console.error('Prop \'subtitle\' is null, undefined, ' +
        'empty, or it\'s not an Array. Please pass the variable ' +
        'as per the documentation. Or according to the following ' +
        'example object:', example)
    }
  }

  colSizeClass (colSize) {
    return `col-${colSize}`
  }
}
export default JtDataGridSubtitle
</script>
<style lang="stylus" scoped>
.align-items-center {
  align-items: center;
}
</style>
